const frontTech = [
  {
    label: 'React',
    image: 'https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg',
  },
  { label: 'Redux', image: 'images/redux.svg' },
  {
    label: 'Chakra UI',
    image: 'images/chakra-ui.svg',
  },
  { label: 'Bootsrap 5', image: 'images/bootstrap-5-1.svg' },
];

const backTech = [
  { label: 'PostgreSQL', image: 'images/postgresql.svg' },
  { label: 'MongoDB', image: 'images/mongodb-icon-1.svg' },
  { label: 'NodeJs', image: 'images/nodejs-icon.svg' },
];

const randTech = [
  { label: 'Javascript', image: 'images/js.svg' },
  { label: 'Typescript', image: 'images/typescript.svg' },
  { label: 'C/C++', image: 'images/c.svg' },
  { label: 'Git', image: 'images/git-icon.svg' },
  { label: 'GitHub', image: 'images/github-icon-1.svg' },
];

export { frontTech, backTech, randTech };
